import { render, staticRenderFns } from "./FormulaTestSubSection.vue?vue&type=template&id=52c4e5d5&scoped=true&"
import script from "./FormulaTestSubSection.vue?vue&type=script&lang=js&"
export * from "./FormulaTestSubSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4e5d5",
  null
  
)

export default component.exports